import { pick } from '../../utils/object';

export default class Batch {
  constructor(options, axiosInstance) {
    Object.assign(this, pick(['method', 'url', 'batcher', 'timeout'], options));
    this.instance = axiosInstance;
    this.requests = [];
    this.resolves = [];
    this.rejects = [];

    this.timeoutId = setTimeout(() => this.fire());
  }

  fire() {
    const config = this.batcher(this.requests);

    this
      .instance({
        ...config,
        ...pick(['method', 'url', 'timeout'], this)
      })
      .then(res => res.forEach((stats, i) => this.resolves[i](stats)))
      .catch(err => this.rejects.forEach(reject => reject(err)));

    if (this.onFiredCallback) {
      this.onFiredCallback();
    }
  }

  add(request) {
    this.requests.push(request);
    return new Promise((resolve, reject) => {
      this.resolves.push(resolve);
      this.rejects.push(reject);
    });
  }

  onFired(callback) {
    this.onFiredCallback = callback;
  }
}



// WEBPACK FOOTER //
// ./src/universal/ui/services/api/Batch.js